import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from '../../../../redux';
import { updateFormatOption } from '../../../../redux/ChartPoperties/ChartControlsActions';
import InputPositiveNumber from '../../CommonFunctions/InputPositiveNumber';
import { Checkbox } from '@mui/material';

/**
 *
 * This component is rendered by GaugeChartFormatting
 * @returns a UI component having a number input for decimal round off and a checkbox to enable or disable it
 */

const RoundOffComponent = ({
  searchIn,
  propKey,
  iconColor,
  backgroundColor,
}: {
  searchIn: string;
  propKey: string;
  iconColor?: string;
  backgroundColor?: string;
}) => {
  const { gaugeChartFormats } = useSelector((state: RootState) => ({
    gaugeChartFormats: state.chartControls.properties[propKey].formatOptions.gaugeChartFormats,
  }));

  const dispatch = useDispatch();

  return (
    <>
      <div className="optionDescription" style={{ paddingTop: '0px' }}>
        <label
          htmlFor="enableDisable"
          className="enableDisableLabel"
          style={{
            paddingLeft: '0px',
            color: iconColor,
          }}
        >
          Round Off
        </label>
      </div>
      <div
        className="optionDescription"
        style={{
          paddingTop: '0px',
          paddingBottom: '0px',
          marginTop: '-7px',
          paddingLeft: '0.25rem',
          backgroundColor: backgroundColor || 'transparent',
        }}
      >
        <Checkbox
          id="enableDisable"
          checked={gaugeChartFormats[searchIn].enableRounding ? true : false}
          style={{
            transform: 'scale(0.8)',
            paddingRight: '0px',
            paddingLeft: '0px',
          }}
          sx={{
            color: iconColor || '#a6a6a6',
            '&.Mui-checked': {
              color: iconColor || '#a6a6a6',
            },
            '&:hover': {
              backgroundColor: 'transparent !important',
            },
          }}
          onChange={() => {
            const updatedValue = {
              ...gaugeChartFormats[searchIn],
              enableRounding: !gaugeChartFormats[searchIn].enableRounding,
            };
            dispatch(updateFormatOption(propKey, 'gaugeChartFormats', searchIn, updatedValue));
          }}
        />
        <div>
          <InputPositiveNumber
            value={gaugeChartFormats[searchIn].roundingDigits}
            updateValue={(value: number) => {
              if (value >= 0 && value <= 4) {
                const updatedValue = {
                  ...gaugeChartFormats[searchIn],
                  roundingDigits: value,
                };
                dispatch(updateFormatOption(propKey, 'gaugeChartFormats', searchIn, updatedValue));
              } else if (value > 4) {
                const updatedValue = {
                  ...gaugeChartFormats[searchIn],
                  roundingDigits: 4,
                };
                dispatch(updateFormatOption(propKey, 'gaugeChartFormats', searchIn, updatedValue));
              } else {
                const updatedValue = {
                  ...gaugeChartFormats[searchIn],
                  roundingDigits: 0,
                };
                dispatch(updateFormatOption(propKey, 'gaugeChartFormats', searchIn, updatedValue));
              }
            }}
            disabled={gaugeChartFormats[searchIn].enableRounding ? false : true}
            iconColor={iconColor}
            backgroundColor={backgroundColor}
            fromFormats={true}
          />
        </div>
        <span style={{ margin: 'auto 0px', fontWeight: 'normal', color: iconColor }}>decimal</span>
      </div>
    </>
  );
};

export default RoundOffComponent;
